export default "__VITE_ASSET__yXI2BO0D__"